import PolicyPage from "./PolicyPage";

export default function ShippingReturnsPage() {
  return (
    <PolicyPage
      eyebrow="Customer Care"
      title="Shipping, Returns and Refunds Policy"
      lastUpdated="June 2026"
      testid="page-shipping-returns"
    >
      <h3 className="text-lg font-bold tracking-tight mt-2" style={{ fontFamily: "Outfit" }}>
        Shipping
      </h3>
      <p>
        We ship with trusted carriers such as Canada Post, UPS, FedEx or Purolator. Shipping
        options, costs and estimated delivery times appear at checkout. Delays may occur due to
        weather, holidays, customs or carrier issues.
      </p>

      <h3 className="text-lg font-bold tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        Tracking and Lost Packages
      </h3>
      <p>
        Tracking will be emailed when available. If your package is delayed or lost, contact us at{" "}
        <a className="underline" href="mailto:info@smibhaluxecandles.com">info@smibhaluxecandles.com</a>{" "}
        with your order number.
      </p>

      <h3 className="text-lg font-bold tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        Damaged Packages
      </h3>
      <p>
        Contact us within 48 hours with your order number and photos of the package and product.
        Keep all packaging. We may offer a replacement or refund, as required by law.
      </p>

      <h3 className="text-lg font-bold tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        Returns and Refunds
      </h3>
      <p>
        We generally do not accept returns for change of mind or unwanted products. If your product
        is defective, damaged, unsafe or not as described, contact us at{" "}
        <a className="underline" href="mailto:info@smibhaluxecandles.com">info@smibhaluxecandles.com</a>.
        We will provide any remedy required by law.
      </p>
      <p>
        Approved refunds are sent to the original payment method. Do not return products without
        written instructions unless the law allows you to do so.
      </p>

      <h3 className="text-lg font-bold tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        Incorrect Address
      </h3>
      <p>
        Please provide an accurate address. If an order is returned because of an incorrect address,
        reshipping or return charges may apply where permitted by law.
      </p>

      <h3 className="text-lg font-bold tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        Order Cancellation
      </h3>
      <p>
        Contact us as soon as possible to request cancellation. Cancellation is not guaranteed after
        processing or shipment.
      </p>

      <h3 className="text-lg font-bold tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        International Orders
      </h3>
      <p>
        Customers are responsible for customs duties, import taxes and other destination-country
        charges unless stated otherwise at checkout.
      </p>

      <h3 className="text-lg font-bold tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        Contact Us
      </h3>
      <p>
        For shipping, returns, refunds or cancellations, email{" "}
        <a className="underline" href="mailto:info@smibhaluxecandles.com">info@smibhaluxecandles.com</a>.
      </p>
    </PolicyPage>
  );
}
